import gql from 'graphql-tag';

export default gql`
    query GetRolePermissions {
        getPermissionRoles {
            categories {
                name
                permissions {
                    id
                    name
                    assignments {
                        roleId
                        isAssigned
                    }
                }
            }
            headers {
                id
                name
            }
        }
    }
`;
